import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "dayjs/locale/ms";
import { zh } from "./zh";
import { en } from "./en";
import { ms } from "./ms";

const savedLang = localStorage.getItem("kawkaw_admin_lang") ?? "zh";

function syncDayjsLocale(lng: string) {
  dayjs.locale(lng.startsWith("zh") ? "zh-cn" : lng === "ms" ? "ms" : "en");
}

void i18n.use(initReactI18next).init({
  resources: {
    zh: zh,
    en: en,
    ms: ms,
  },
  lng: savedLang,
  fallbackLng: "zh",
  interpolation: {
    escapeValue: false,
  },
});

syncDayjsLocale(savedLang);
i18n.on("languageChanged", syncDayjsLocale);

export default i18n;
export const SUPPORTED = ["en", "ms", "zh"] as const;
export type SupportedLang = (typeof SUPPORTED)[number];
